// src/app/auth.interceptor.ts (or wherever you saved it)

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class GoogleAuthInterceptor implements HttpInterceptor { // Give it a unique name

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = localStorage.getItem('auth_token');

    // Check if the token exists
    if (authToken) {
      // Clone the request to add the new header.
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`)
      });
      // Pass the cloned request to the next handler.
      return next.handle(authReq);
    }

    // If no token, pass the original request without modification
    return next.handle(req);
  }
}